import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { ConnectionsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createConnection = (data): any => action(types.CREATE_CONNECTION_REQUESTED, data);

export const updateConnection = (data): any => action(types.UPDATE_CONNECTION_REQUESTED, data);

export const deleteConnection = (connectionId): any => action(types.DELETE_CONNECTION_REQUESTED, connectionId);

export const getConnection = (connectionId): any => action(types.GET_CONNECTION_REQUESTED, connectionId);

export const getAllConnections = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_CONNECTIONS_REQUESTED, {
  pagination,
  compile,
});

export const selectConnection = (connectionId): any => action(types.SELECT_CONNECTION_REQUESTED, {
  currentConnectionId: connectionId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createConnectionPending: (payload): any => action(types.CREATE_CONNECTION_PENDING, payload),
  createConnectionSuccess: (response): any => {
    const currentConnection = response.entities.connections[response.result];
    // history.push(`/payment/${currentConnection.paymentCollection.id}/review`);
    return action(types.CREATE_CONNECTION_SUCCESS, {
      connectionsById: response.entities.connections,
      currentConnectionId: response.result,
    });
  },
  updateConnectionPending: (payload): any => action(types.UPDATE_CONNECTION_PENDING, payload),
  updateConnectionSuccess: (response): any => action(types.UPDATE_CONNECTION_SUCCESS, {
    connectionsById: response.entities.connections,
    currentConnectionId: response.result,
  }),
  updateConnectionFailed: (error): any => action(types.UPDATE_CONNECTION_FAIL, {
    backendErrors: error,
  }),
  deleteConnectionPending: (response): any => action(types.DELETE_CONNECTION_PENDING, response),
  deleteConnectionSuccess: (response): any => action(types.DELETE_CONNECTION_SUCCESS, {
    currentConnectionId: response,
  }),
  getConnectionPending: (): any => action(types.GET_CONNECTION_PENDING, {}),
  getConnectionSuccess: (response): any => action(types.GET_CONNECTION_SUCCESS, {
    connectionsById: response.entities.connections,
    currentConnectionId: response.result,
  }),
  getConnectionFailed: (error): any => action(types.GET_CONNECTION_FAIL, {
    backendErrors: error,
  }),
  deleteConnectionFailed: (error): any => action(types.DELETE_CONNECTION_FAIL, {
    backendErrors: error,
  }),
  getAllConnectionsPending: (pagination): any => action(types.GET_ALL_CONNECTIONS_PENDING, { pagination }),
  getAllConnectionsSuccess: (response, meta): any => action(types.GET_ALL_CONNECTIONS_SUCCESS, {
    connectionsById: response.entities.connections,
    connectionIds: response.result,
    meta,
  }),
  getAllConnectionsFailed: (error): any => action(types.GET_ALL_CONNECTIONS_FAIL, {
    backendErrors: error,
  }),
  createConnectionFailed: (error): any => action(types.CREATE_CONNECTION_FAIL, {
    backendErrors: error,
  }),
};

export default null;
